import { QueryClientProvider, type QueryClient } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { Toaster } from "sonner";

import { TooltipProvider } from "@/components/ui";
import { ThemeProvider, useResolvedTheme } from "@/lib/theme";

function ThemedToaster() {
  const theme = useResolvedTheme();
  // in the app, below the status bar (--safe-top is 0 on the website: sonner's defaults)
  return (
    <Toaster
      theme={theme}
      position="top-right"
      richColors
      closeButton
      offset={{ top: "calc(var(--safe-top) + 24px)" }}
      mobileOffset={{ top: "calc(var(--safe-top) + 16px)" }}
    />
  );
}

export function AppProviders({ queryClient, children }: { queryClient: QueryClient; children: ReactNode }) {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={200}>
          {children}
          <ThemedToaster />
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
